<template>
  <div class="v-date-range">
    <v-menu
      v-model="menu"
      :close-on-content-click="false"
      offset-y
      v-bind="menuProps"
    >
      <v-layout
        slot="activator"
        align-center
        justify-end
        class="daterange-activator"
        
        >
        <!-- <div class="daterange-activator-value">{{ inputValue }}</div> -->
        <!--<v-icon color="primary">date_range</v-icon>-->
        <img class="calender-icon" :src="require('./img/calender.svg')" v-tippy="{
          placement: 'right',
          arrow: true,
          arrowTransform: 'scale(0.75)',
          theme: 'lgrm-tooltip-tippy'
        }"
        title="Date Range"/>
      </v-layout>
      <v-card class="v-date-range__menu-content">
        <v-card-text>
          <div
            :data-days="highlightDates.length"
            :class="{
              'v-date-range__pickers': true,
              'v-date-range--highlighted': highlightDates.length
            }"
          >
            <v-card-title v-if="$slots.title">
              <slot name="title" v-if="$slots.title"></slot>
            </v-card-title>
            <v-card-text>
              <div class="v-date-range__content">
                <v-list v-if="!noPresets" class="mr-4">
                  <v-subheader>{{ presetLabel }}</v-subheader>
                  <v-list-tile
                    v-for="(preset, index) in presets"
                    v-model="isPresetActive[index]"
                    :key="index"
                    @click="selectPreset(index)"
                    class="preset-item"
                  >
                    <v-list-tile-content>
                      {{ preset.label }}
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
                <v-date-picker
                  class="mr-4 v-date-range__picker--start v-date-range__picker"
                  v-model="pickerStart"
                  :locale="locale"
                  :first-day-of-week="firstDayOfWeek"
                  :min="min"
                  :max="pickerEnd || max"
                  :no-title="noTitle"
                  :next-icon="nextIcon"
                  :prev-icon="prevIcon"
                  :events="highlightDates"
                  :event-color="highlightClasses"
                  color="accent"
                ></v-date-picker>
                <v-date-picker
                  class="v-date-range__picker--end v-date-range__picker"
                  v-model="pickerEnd"
                  :locale="locale"
                  :first-day-of-week="firstDayOfWeek"
                  :min="pickerStart || min"
                  :max="max"
                  :no-title="noTitle"
                  :next-icon="nextIcon"
                  :prev-icon="prevIcon"
                  :events="highlightDates"
                  :event-color="highlightClasses"
                  color="accent"
                ></v-date-picker>
              </div>
            </v-card-text>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn depressed="" color="primaryLight7" light round @click="reset">Reset</v-btn>
          <v-btn depressed="" color="primaryLight7" light round @click="menu = false">Cancel</v-btn>
          <v-btn
            @click="applyRange"
            depressed
            color="accent"
            dark
            round
            :disabled="!bothSelected"
            >Apply</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-menu>
  </div>
</template>
<script>
import format from 'date-fns/format'
import parse from 'date-fns/parse'
import differenceInCalendarDays from 'date-fns/difference_in_calendar_days'
import addDays from 'date-fns/add_days'
const isoFormat = 'YYYY-MM-DD'
const defaultDate = format(new Date(), isoFormat)

export default {
  name: 'v-daterange',
  props: {
    // Take start and end as the input. Passable via v-model.
    value: {
      type: Object,
      default: () => {
        return { from: defaultDate, to: defaultDate }
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    presets: {
      type: Array,
      default: () => {
        return []
      }
    },
    noPresets: {
      type: Boolean,
      default: false
    },
    // Denotes the Placeholder string for from date.
    startLabel: {
      type: String,
      default: 'from Date'
    },
    // Denotes the Placeholder string for from date.
    endLabel: {
      type: String,
      default: 'to Date'
    },
    // The string that gets placed between `startLabel` and `endLabel`
    separatorLabel: {
      type: String,
      default: '-'
    },
    presetLabel: {
      type: String,
      default: 'Presets'
    },
    /**
     * Following values are all passable to vuetify's own datepicker
     * component.
     */
    // Min selectable date.
    min: {
      type: String,
      default: undefined
    },
    // Max selectable date
    max: {
      type: String,
      default: undefined
    },
    // Locale
    locale: {
      type: String,
      default: 'en-us'
    },
    firstDayOfWeek: {
      type: [String, Number],
      default: 0
    },
    noTitle: {
      type: Boolean,
      default: false
    },
    displayFormat: {
      type: String,
      default: 'DD MMM, YYYY'
    },
    highlightColor: {
      type: String,
      default: 'blue lighten-5'
    },
    showReset: {
      type: Boolean,
      default: true
    },
    /**
     * Icons
     */
    nextIcon: {
      type: String,
      default: '$vuetify.icons.next'
    },
    prevIcon: {
      type: String,
      default: '$vuetify.icons.prev'
    },
    inputProps: {
      type: Object,
      default: () => {
        return {}
      }
    },
    menuProps: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    console.log(this.value)
    return {
      menu: false,
      pickerStart: this.value.from,
      pickerEnd: this.value.to,
      highlightDates: [],
      highlightClasses: {}
    }
  },
  computed: {
    inputValue() {
      if (this.isValueEmpty) {
        return ''
      }
      const preset = this.presets.find(
        d => d.range[0] === this.value.from && d.range[1] === this.value.to
      )
      if (preset) return preset.label
      const from = this.displayFormat
        ? this.formatDate(this.value.from, this.displayFormat)
        : this.value.from
      const to = this.displayFormat
        ? this.formatDate(this.value.to, this.displayFormat)
        : this.value.to
      return `${from}    ${this.separatorLabel}     ${to}`
    },
    placeholder() {
      return `${this.startLabel}    ${this.separatorLabel}    ${this.endLabel}`
    },
    /**
     * If the value prop doesn't have any from value,
     * its most likely that an empty object was passed.
     */
    isValueEmpty() {
      return !this.value.from
    },
    /**
     * If the user has selected both the dates or not
     */
    bothSelected() {
      return this.pickerStart && this.pickerEnd
    },
    isPresetActive() {
      return this.presets.map(
        preset =>
          preset.range[0] === this.pickerStart &&
          preset.range[1] === this.pickerEnd
      )
    }
  },
  methods: {
    /**
     * Emit the input event with the updated range data.
     * This makes v-model work.
     */
    applyRange() {
      this.menu = false
      this.emitRange()
    },
    /**
     * Called every time the menu is closed.
     * It also emits an event to tell the parent
     * that the menu has closed.
     *
     * Upon closing the datepicker values are set
     * to the current selected value.
     */
    closeMenu() {
      // Reset the changed values for datepicker models.
      this.pickerStart = this.value.from
      this.pickerEnd = this.value.to
      this.highlight()
      this.$emit('menu-closed')
    },
    formatDate(date, fmt) {
      return format(parse(date), fmt)
    },
    highlight() {
      if (!this.bothSelected) {
        return
      }
      const dates = []
      const classes = {}
      const from = parse(this.pickerStart)
      const to = parse(this.pickerEnd)
      const diff = Math.abs(differenceInCalendarDays(from, to))

      // Loop though all the days in range.
      for (let i = 0; i <= diff; i++) {
        const date = format(addDays(from, i), isoFormat)
        dates.push(date)
        const classesArr = []
        classesArr.push(`v-date-range__in-range`)
        classesArr.push(this.highlightColor)
        i === 0 && classesArr.push(`v-date-range__range-start`)
        i === diff && classesArr.push(`v-date-range__range-end`)
        classes[date] = classesArr.join(' ')
      }
      this.highlightDates = dates
      this.highlightClasses = classes
    },
    selectPreset(presetIndex) {
      this.pickerStart = this.presets[presetIndex].range[0]
      this.pickerEnd = this.presets[presetIndex].range[1]
    },
    reset() {
      // Reset Picker Values
      this.pickerStart = this.presets[0].range[0]
      this.pickerEnd = this.presets[0].range[1]
      this.emitRange()
    },
    emitRange() {
      this.$emit('input', {
        from: this.pickerStart,
        to: this.pickerEnd
      })
    },
    matchingPreset: function(from_date, to_date) {}
  },
  watch: {
    // Watching to see if the menu is closed.
    menu(isOpen) {
      if (!isOpen) {
        this.closeMenu()
      } else {
        this.highlight()
      }
    },
    pickerStart: 'highlight',
    pickerEnd: 'highlight'
  }
}
</script>
<style scoped lang="stylus">
    .v-date-range__menu-content {
        .theme--light.v-btn{
          color: $color-primary-light-1
        }
    }
    .calender-icon {
        width 25px
    }
.v-date-range__input-field >>> input {
  text-align: center;
}

.v-date-range__content .v-date-picker-table .v-btn {
    color: $color-primary-light-1 !important
}

/* =============================================
=            Menu Content            =
============================================= */
.v-date-range__content {
  display: flex;

  >>> .v-date-picker-table {
    .v-btn {
      border-radius: 0;
    }
  }
}

/* =====  End of Menu Content  ====== */
.v-date-range__pickers >>> .v-date-picker-table__events {
  height: 100%;
  width: 100%;
  top: 0;
  z-index: -1;
}

/* =============================================
=            Date buttons            =
============================================= */
.v-date-range__pickers >>> .v-date-picker-table table {
  width: auto;
  margin: auto;
  border-collapse: collapse;

  & th, & td {
    height: 32px;
    width: 32px;
  }

  & td {
    .v-btn {
      &.v-btn--outline {
        border: none;
        box-shadow: 0 0 0 1px currentColor inset;
      }

      &.v-btn--active::before {
        background-color: transparent !important;
      }
    }
  }
}


/* =====  End of Date buttons  ====== */
/* =============================================
=            Highlighting the even bubble dot            =
============================================= */
.v-date-range__pickers >>> .v-date-range__in-range {
    height: 100%;
    width: 100%;
    margin: 0;
    border-radius: 0;
}
.v-date-range {
    .daterange-activator {
        border: 1px solid $color-primary-light-8;
        box-sizing: border-box;
        text-transform none
        // min-width 85px
        border-radius: 5px
        height 40px
        text-align right
        padding-left 10px
        padding-right 10px
    }
    .daterange-activator-value {
        padding-right: 10px
    }
}
    .preset-item {
        height 35px
        >>> .v-list__tile {
            height 35px
            font-size 14px
            padding 0
        }
    }

/* =====  End of Highlighting the even bubble dot  ====== */
</style>

<style lang="stylus">

.theme--light.v-date-picker-table th {
  color: $color-primary-light-5 !important
}
.v-date-range__content .theme--light.v-subheader{
  color: $color-primary-light-5 
  }

.v-date-range__content  .v-btn__content {
  color: $color-primary-light-2
  }
</style>
